// extracted by mini-css-extract-plugin
export default {"container":"LoadingComponent__container___HdfAX","rotateIcon":"LoadingComponent__rotateIcon___FZomc"};